__turbopack_context__.v({
  "button": "stepper-module-scss-module__-ZwxzG__button",
  "icon": "stepper-module-scss-module__-ZwxzG__icon",
  "input": "stepper-module-scss-module__-ZwxzG__input",
  "placeholder": "stepper-module-scss-module__-ZwxzG__placeholder",
  "stepper": "stepper-module-scss-module__-ZwxzG__stepper",
});
